module.exports = __webpack_public_path__ + "img/logo.118c02f3.png";